import { render } from "./SettingsExport.vue?vue&type=template&id=a7733ae2&ts=true"
import script from "./SettingsExport.vue?vue&type=script&lang=ts"
export * from "./SettingsExport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__